import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SyncIcon = function SyncIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SyncIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      d: "M5.485 4.2H4.131a5.46 5.46 0 0 1 2.012-1.278 5.5 5.5 0 0 1 3.368-.117 5.46 5.46 0 0 1 2.793 1.868 5.4 5.4 0 0 1 1.066 2.346c.08.433.447.78.891.765.445-.016.797-.387.731-.822a6.97 6.97 0 0 0-1.419-3.272 7.07 7.07 0 0 0-3.619-2.419 7.12 7.12 0 0 0-4.362.151 7.07 7.07 0 0 0-2.83 1.892V2c0-.442-.362-.8-.808-.8a.804.804 0 0 0-.807.8v3c0 .442.361.8.807.8h3.531a.804.804 0 0 0 .808-.8c0-.442-.362-.8-.808-.8M10.53 10.2a.804.804 0 0 0-.807.8c0 .442.361.8.807.8h1.355a5.46 5.46 0 0 1-2.102 1.31 5.5 5.5 0 0 1-3.37.058 5.45 5.45 0 0 1-2.76-1.916A5.4 5.4 0 0 1 2.63 8.888c-.073-.434-.433-.787-.878-.78-.444.008-.803.373-.745.81a6.97 6.97 0 0 0 1.361 3.295 7.06 7.06 0 0 0 3.576 2.481 7.12 7.12 0 0 0 4.364-.075 7.07 7.07 0 0 0 2.947-1.933V14c0 .442.362.8.807.8a.804.804 0 0 0 .807-.8v-3c0-.442-.361-.8-.807-.8z"
    })
  }));
};

export { SyncIcon };
